document.addEventListener("DOMContentLoaded", function () {
  const dropdown = document.querySelector("[data-sort-dropdown]");
  const toggle = dropdown.querySelector("[data-sort-toggle]");
  const clickListner = dropdown.querySelector("[data-sort-click-listner]");
  const menu = dropdown.querySelector("[data-sort-menu]");
  const select = document.querySelector("[data-sort-select]");
  const form = select.closest("form");
  const caret = dropdown.querySelector("[data-sort-caret]");
  const selectedOption = select.querySelector("option[selected]");
  
  if (selectedOption) {
    toggle.textContent = selectedOption.textContent.trim();
  } 
  else {
    toggle.textContent = "Sort By";
  }  

  clickListner.addEventListener("click", function (event) {
    event.preventDefault();
    const isOpen = menu.classList.toggle("open");
    caret.classList.toggle("sort-dropdown__caret--open", isOpen);
  });

  menu.querySelectorAll("[data-sort-value]").forEach(function (item) {
    item.addEventListener("click", function (event) {
      event.preventDefault();

      const value = item.getAttribute("data-sort-value");
      select.value = value;
      select.dispatchEvent(new Event("change", { bubbles: true }));
      toggle.textContent = item.textContent;
      menu.querySelectorAll("[data-sort-value]").forEach(el => el.classList.remove("selected"));
      item.classList.add("selected");
      menu.classList.remove("open");
      caret.classList.remove("sort-dropdown__caret--open");
      if (form) form.submit();
    });
  });

  document.addEventListener("click", function (e) {
    if (!dropdown.contains(e.target)) {
      menu.classList.remove("open");
      caret.classList.remove("sort-dropdown__caret--open");
    }
  });
});